import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class QuestionnaireItemWidgetProps extends BackboneElement {
    static __className = 'WidgetProps';

    __objectStructure = {
        editDemographics: Boolean,
        diagnosisDisplayCriteria: Boolean,
        defaultDiagnosisStatus: String,
        defaultProblemStatus: String,
        problemList: Boolean,
        dobRequired: Boolean,
        addressRequired: Boolean,
        showAllActiveRelease: Boolean,
        allowAssessment: Boolean,
        allowReassessment: Boolean,
        treatmentPlanMedsOnly: Boolean,
    };

    constructor(constructJson, className = 'WidgetProps') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
